
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/get-certified/ethics-and-enforcement",
      function () {
        return require("private-next-pages/get-certified/ethics-and-enforcement.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/get-certified/ethics-and-enforcement"])
      });
    }
  